import React, { useRef, useState } from "react";
import { useBreakpoint } from "hooks";
import ArrowRight from "images/icons/arrow-right.inline.svg";

export const VIPriceAccordion = ({ className, children }) => {
  const [isOpened, setOpened] = useState(false);
  const [height, setHeight] = useState("0px");
  const breakpoint = useBreakpoint();
  const contentElement = useRef(null);
  const handleAccordion = () => {
    setOpened(!isOpened);
    setHeight(!isOpened ? `${contentElement.current.scrollHeight}px` : "0px");
  };

  return (
    <>
      <div
        className={`flex justify-between items-center p-4  bg-yellow-standard dark:bg-gray-standard gvi-box-shadow rounded-xs ${className}`}
        onClick={handleAccordion}
      >
        <p className="h7 !text-white !text-base uppercase">
          What&apos;s included?
        </p>
        <ArrowRight
          className={`visible w-3 h-3 stroke-white ${
            isOpened ? "-rotate-90" : "rotate-90"
          }`}
        />
      </div>
      <div
        ref={contentElement}
        className="overflow-hidden transition-all duration-200"
        style={{ height: ["xs", "sm"].includes(breakpoint) ? "" : height }}
      >
        {["xs", "sm"].includes(breakpoint) ? isOpened && children : children}
      </div>
    </>
  );
};
